import React, { useState, useEffect, useRef } from 'react';
import { AiOutlineClose } from 'react-icons/ai';
import { Link } from 'react-scroll';
import { BsFillMenuButtonWideFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import translations from '../translations';
import './Navbar.css';

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const sideMenuRef = useRef(null);
  const navigate = useNavigate();
  const { lang, toggleLang } = useLanguage();
  const t = translations[lang];
  const isRTL = lang === 'ar';

  const handleNav = () => setNav(!nav);

  const handleAboutUsClick = () => {
    navigate('/about-us');
    setNav(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sideMenuRef.current && !sideMenuRef.current.contains(event.target)) {
        setNav(false);
      }
    };

    let startX = 0;
    const handleTouchStart = (event) => { startX = event.touches[0].clientX; };
    const handleTouchEnd = (event) => {
      const diff = startX - event.changedTouches[0].clientX;
      if (isRTL ? diff < -50 : diff > 50) setNav(false);
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleTouchStart);
    document.addEventListener('touchend', handleTouchEnd);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, [isRTL]);

  const drawerClasses = isRTL
    ? `fixed right-0 top-0 w-[60%] h-full border-l border-l-gray-100 bg-[#111820] transition-transform duration-300 z-50 ${nav ? 'translate-x-0' : 'translate-x-full'}`
    : `fixed left-0 top-0 w-[60%] h-full border-r border-r-gray-100 bg-[#111820] transition-transform duration-300 z-50 ${nav ? 'translate-x-0' : '-translate-x-full'}`;

  return (
    <div className='flex sticky top-0 justify-end items-center h-24 mx-auto px-4 text-white z-50 bg-gradient-to-b from-black to-transparent' dir={isRTL ? 'rtl' : 'ltr'}>
      <h1 className='w-full font-magistral text-3xl font-bold text-[#97d700]'>Tech Resources</h1>
      <ul className={`font-magistral hidden md:flex items-center ${isRTL ? 'font-arabic' : ''}`}>
        <li className='p-4 whitespace-nowrap'><Link to="hero" smooth={true} duration={500} spy={true}>{t.nav_home}</Link></li>
        <li className='p-4 whitespace-nowrap'><Link to="contact" smooth={true} duration={500} spy={true}>{t.nav_contact}</Link></li>
        <li className='p-4 whitespace-nowrap'><Link to="partners" smooth={true} duration={500} spy={true}>{t.nav_partners}</Link></li>
        <li className='p-4 whitespace-nowrap'><Link to="vendors" smooth={true} duration={500} spy={true}>{t.nav_vendors}</Link></li>
        <li className='p-4 whitespace-nowrap'><Link to="about-us" smooth={true} duration={500} onClick={handleAboutUsClick}>{t.nav_about}</Link></li>
        <li className='p-4'>
          <button
            onClick={toggleLang}
            className='border border-[#97d700] text-[#97d700] px-3 py-1 rounded text-sm font-magistral hover:bg-[#97d700] hover:text-black transition-colors duration-200'
          >
            {t.nav_lang}
          </button>
        </li>
      </ul>
      <div onClick={handleNav} className='block md:hidden'>
        {nav ? <AiOutlineClose size={20} /> : <BsFillMenuButtonWideFill size={20} />}
      </div>
      <div ref={sideMenuRef} className={drawerClasses}>
        <h1 className='pt-6 w-full font-magistral text-3xl font-bold text-[#97d700] px-4'>Tech Resources</h1>
        <ul className={`pt-4 font-magistral uppercase ${isRTL ? 'font-arabic' : ''}`}>
          <li className='p-4 border-b whitespace-nowrap'><Link to="hero" smooth={true} duration={500} onClick={handleNav} spy={true}>{t.nav_home}</Link></li>
          <li className='p-4 border-b whitespace-nowrap'><Link to="contact" smooth={true} duration={500} onClick={handleNav} spy={true}>{t.nav_contact}</Link></li>
          <li className='p-4 border-b whitespace-nowrap'><Link to="partners" smooth={true} duration={500} onClick={handleNav} spy={true}>{t.nav_partners}</Link></li>
          <li className='p-4 border-b whitespace-nowrap'><Link to="vendors" smooth={true} duration={500} onClick={handleNav} spy={true}>{t.nav_vendors}</Link></li>
          <li className='p-4 border-b whitespace-nowrap'><Link to="about-us" smooth={true} duration={500} onClick={handleAboutUsClick}>{t.nav_about}</Link></li>
          <li className='p-4 border-b'>
            <button
              onClick={() => { toggleLang(); setNav(false); }}
              className='border border-[#97d700] text-[#97d700] px-3 py-1 rounded text-sm hover:bg-[#97d700] hover:text-black transition-colors duration-200'
            >
              {t.nav_lang}
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Navbar;
